import React from 'react';
import { motion, Variants } from 'framer-motion';

interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  y?: number;
  direction?: 'up' | 'left' | 'right' | 'none';
  className?: string;
  style?: React.CSSProperties;
  as?: 'div' | 'span';
}

const variants = (direction: RevealProps['direction'], y: number): Variants => {
  const offset =
    direction === 'left' ? { x: -y, y: 0 } :
    direction === 'right' ? { x: y, y: 0 } :
    direction === 'none' ? { x: 0, y: 0 } :
    { x: 0, y };
  return {
    hidden: { opacity: 0, ...offset },
    visible: { opacity: 1, x: 0, y: 0 },
  };
};

/** Fades + slides content in once it scrolls into view. Respects reduced motion. */
const Reveal: React.FC<RevealProps> = ({ children, delay = 0, y = 28, direction = 'up', className, style }) => (
  <motion.div
    className={className}
    style={style}
    variants={variants(direction, y)}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, margin: '-80px' }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export default Reveal;
